module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.episodes) ? _c('section', [_c('div', {
    staticClass: "episodes container"
  }, _vm._l((_vm.episodes), function(episode) {
    return _c('episode-module', {
      key: episode.slug,
      attrs: {
        "episode": episode
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "container text-right"
  }, [_c('router-link', {
    staticClass: "button button-underline",
    attrs: {
      "to": {
        name: 'Episodes'
      }
    }
  }, [_vm._v("All Episodes")])], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a3e3787"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/LatestEpisodes.vue
// module id = 771
// module chunks = 1